import { ReactNode, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import AboutHareengSection from "@/components/AboutHareengSection";
import AppNavbar from "@/components/common/AppNavbar";
import Shimmer from "@/components/common/Shimmer";
import DownloadAppSection from "@/components/DownloadAppSection";
import EarnWithHareeng from "@/components/EarnWithHareeng";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import OpportunitiesSlider from "@/components/OpportunitiesSlider";
import SafetySection from "@/components/SafetySection";
import ScooterSection from "@/components/ScooterSection";
import UpdatesSection from "@/components/UpdatesSection";

interface MasterLayoutProps {
  children?: ReactNode;
  loading?: boolean;
}

export default function MasterLayout({
  children,
  loading = false,
}: MasterLayoutProps = {}) {
  // Individual loading states for each section (simulate async loading)
  const [heroLoading, setHeroLoading] = useState(true);
  const [sliderLoading, setSliderLoading] = useState(true);
  const [earnLoading, setEarnLoading] = useState(true);
  const [safetyLoading, setSafetyLoading] = useState(true);
  const [scooterLoading, setScooterLoading] = useState(true);
  const [aboutLoading, setAboutLoading] = useState(true);
  const [downloadLoading, setDownloadLoading] = useState(true);
  const [updatesLoading, setUpdatesLoading] = useState(true);

  useEffect(() => {
    // Simulate async loading for each section
    const timers = [
      setTimeout(() => setHeroLoading(false), 300),
      setTimeout(() => setSliderLoading(false), 400),
      setTimeout(() => setEarnLoading(false), 500),
      setTimeout(() => setSafetyLoading(false), 600),
      setTimeout(() => setScooterLoading(false), 700),
      setTimeout(() => setAboutLoading(false), 800),
      setTimeout(() => setDownloadLoading(false), 900),
      setTimeout(() => setUpdatesLoading(false), 1000),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-base-100">
      <AppNavbar />
      {loading ? (
        <Shimmer />
      ) : (
        <>
          {heroLoading ? <Shimmer /> : <Hero />}
          {earnLoading ? <Shimmer /> : <EarnWithHareeng />}
          {sliderLoading ? <Shimmer /> : <OpportunitiesSlider />}
          {safetyLoading ? <Shimmer /> : <SafetySection />}
          {scooterLoading ? <Shimmer /> : <ScooterSection />}
          {aboutLoading ? <Shimmer /> : <AboutHareengSection />}
          {/* {downloadLoading ? <Shimmer /> : <DownloadAppSection />} */}
          {updatesLoading ? <Shimmer /> : <UpdatesSection />}
          <Footer />
        </>
      )}
    </div>
  );
}
